import { useState } from 'react';
import { motion } from 'motion/react';
import { Btn } from '../ui/Btn.jsx';
import { supaSignIn, supaSignInWithGoogle, supaResetPassword, pullFromSupabase } from '../../lib/supabase.js';
import { scaleIn, tapScale } from '../../lib/motionPresets.js';

export function SignInScreen({onSuccess,onBack}){
  const[email,setEmail]=useState('');const[pw,setPw]=useState('');const[err,setErr]=useState('');const[busy,setBusy]=useState(false);const[resetSent,setResetSent]=useState(false);const[showReset,setShowReset]=useState(false);
  const doSignIn=async()=>{
    if(!email||!pw){setErr('Please enter your email and password.');return;}
    setBusy(true);setErr('');
    try{
      const{data,error}=await supaSignIn(email.trim(),pw);
      setBusy(false);
      if(error){setErr(error.message);return;}
      const pulled=await pullFromSupabase();
      onSuccess(data,pulled);
    }catch{
      setBusy(false);
      setErr('Connection error. Please try again.');
    }
  };
  const doReset=async()=>{
    if(!email){setErr('Enter your email above first.');return;}
    setBusy(true);setErr('');
    try{
      const{error}=await supaResetPassword(email.trim());
      setBusy(false);
      if(error){setErr(error.message);return;}
      setResetSent(true);
    }catch{
      setBusy(false);
      setErr('Connection error. Please try again.');
    }
  };
  if(showReset)return <motion.div {...scaleIn} className="px-6 py-8 text-center">
    <div className="mx-auto max-w-md rounded-finley-xl bg-finley-bg-card px-6 py-8 shadow-finley-md">
      <div className="mb-3 text-5xl">📧</div>
      <div className="mb-2 font-finley-display text-3xl text-finley-text">Reset Password</div>
      <div className="mb-5 text-sm leading-6 text-finley-text-light">Enter your email and we'll send a reset link.</div>
      {err&&<div className="mb-3 rounded-finley-md bg-finley-error/10 px-3 py-2 text-sm text-finley-error">{err}</div>}
      {resetSent&&<div className="mb-3 rounded-finley-md bg-finley-success/10 px-3 py-2 text-sm text-finley-success">Reset link sent! Check your email.</div>}
      <input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="mb-3 w-full rounded-finley-md border-2 border-finley-text-muted/20 bg-finley-bg px-4 py-3 text-base text-finley-text outline-none" autoCapitalize="none" autoCorrect="off"/>
      <Btn onClick={doReset} disabled={busy} full>{busy?'Sending...':'Send Reset Link'}</Btn>
      <motion.button {...tapScale} onClick={()=>{setShowReset(false);setErr('');setResetSent(false);}} className="mt-4 text-sm text-finley-secondary">Back to Sign In</motion.button>
    </div>
  </motion.div>;
  return <motion.div {...scaleIn} className="px-6 py-8 text-center">
    <div className="mx-auto max-w-md rounded-finley-xl bg-finley-bg-card px-6 py-8 shadow-finley-md">
    <div className="mb-3 text-5xl">🐬</div>
    <div className="mb-2 font-finley-display text-3xl text-finley-text">Welcome Back</div>
    <div className="mb-5 text-sm leading-6 text-finley-text-light">Sign in to sync your child's progress across devices.</div>
    {err&&<div className="mb-3 rounded-finley-md bg-finley-error/10 px-3 py-2 text-sm text-finley-error">{err}</div>}
    <motion.button {...tapScale} onClick={async()=>{const r=await supaSignInWithGoogle();if(r.error)setErr(r.error.message||'Google sign-in unavailable.');}} className="mb-4 flex min-h-[56px] w-full items-center justify-center gap-3 rounded-finley-lg border border-finley-text-muted/20 bg-white px-4 py-3 text-base font-semibold text-[#3c4043] shadow-finley-sm">
      <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#34A853" d="M10.53 28.59a14.5 14.5 0 010-9.18l-7.98-6.19a24.01 24.01 0 000 21.56l7.98-6.19z"/><path fill="#FBBC05" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
      Continue with Google
    </motion.button>
    <div className="mb-4 flex items-center gap-3"><div className="h-px flex-1 bg-finley-text-muted/20"/><span className="text-sm text-finley-text-light">or</span><div className="h-px flex-1 bg-finley-text-muted/20"/></div>
    <input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="mb-3 w-full rounded-finley-md border-2 border-finley-text-muted/20 bg-finley-bg px-4 py-3 text-base text-finley-text outline-none" autoCapitalize="none" autoCorrect="off"/>
    <input type="password" placeholder="Password" value={pw} onChange={e=>setPw(e.target.value)} onKeyDown={e=>{if(e.key==='Enter')doSignIn();}} className="mb-4 w-full rounded-finley-md border-2 border-finley-text-muted/20 bg-finley-bg px-4 py-3 text-base text-finley-text outline-none"/>
    <Btn onClick={doSignIn} disabled={busy} full>{busy?'Signing in...':'Sign In'}</Btn>
    <motion.button {...tapScale} onClick={()=>{setShowReset(true);setErr('');}} className="mt-4 block w-full text-sm text-finley-secondary">Forgot password?</motion.button>
    <motion.button {...tapScale} onClick={onBack} className="mt-3 block w-full text-sm text-finley-text-light">Back</motion.button>
    </div>
  </motion.div>;
}

// ── PASSWORD RECOVERY SCREEN ────────────────────────────
